import React, { useCallback } from "react";

export default function(props) {
  const { onClick = () => undefined } = props;

  const handleClick = useCallback(() => {
    onClick();
  }, []);

  return (
    <div
      id="go-to-bottom"
      className="nav-scroll absolute"
      onClick={handleClick}
    >
      <p>TO BOTTOM</p>
      <i className="arrow down" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ScrollToBottom.js